// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c73565c3","404":"256c2744","545":"41a4dcb0","787":"c8f977bb","897":"3a14d54b"}[chunkId] + ".chunk.js";
};